import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { getThemeConfig, ShimmerAvatarCircle, ShimmerAvatarContainer, ShimmerAvatarContent } from '../styles';
import ShimmerBodyText from './ShimmerBodyText';
import ShimmerTitleText from './ShimmerTitleText';

var ShimmerAvatar = function ShimmerAvatar(_ref) {
  var _ref$content = _ref.content,
      content = _ref$content === void 0 ? true : _ref$content,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      dataTest = _ref['data-test'],
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["content", "size", "data-test", "width", "theme"]);

  var isSmallTitle = size === 'xs' || size === 'xxs';
  var componentTheme = useComponentTheme({
    name: 'Shimmer',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(ShimmerAvatarContainer, _extends({
    isSmallTitle: isSmallTitle,
    "data-test": dataTest,
    $width: width
  }, props), /*#__PURE__*/React.createElement(ShimmerAvatarCircle, _extends({
    size: size,
    customTheme: componentTheme
  }, props, {
    "data-test": "".concat(dataTest, "-circle")
  })), content ? /*#__PURE__*/React.createElement(ShimmerAvatarContent, _extends({
    size: size
  }, props, {
    "data-test": "".concat(dataTest, "-content")
  }), /*#__PURE__*/React.createElement(ShimmerTitleText, {
    size: isSmallTitle ? 'sm' : 'lg'
  }), /*#__PURE__*/React.createElement(ShimmerBodyText, null)) : undefined);
};

ShimmerAvatar.displayName = 'ShimmerAvatar';
export default ShimmerAvatar;